<template>
  <div v-if="isLoad">
    <div class="columns is-multiline" v-if="!detail">
      <selecteur-action
        @handleAction="handleAction"
        :options="actions"
        :placeholder='$t("general.placeHolder.groupedAction")'
        :elementsSelectionnes="getAllSelected.length > 0"
        titleButton="general.button.apply"
        class="column is-narrow mgb-0">
      </selecteur-action>
      <div class="column has-text-right">
        <a class="button is-addOrEdit" @click="addLigne()">
          {{ $t('produitSalon.regleCommission.actions.add')}}
        </a>
      </div>
    </div>
    <div v-else class="columns is-justify-content-end is-align-items-end">
      <div class="column" v-if="produit.regroupementProduit && showMsgRegroupementProduit">
        <msg-info-produit :regroupementProduit="produit.regroupementProduit"/>
      </div>
      <div class="columns is-justify-content-end is-align-items-end">
        <div class="column is-narrow is-align-self-center">
          <div class="lien has-text-right">
            <span class="is-cursor-pointer" @click="displayInactif = !displayInactif">
              {{ displayInactif
                ? $t('produitSalon.regleCommission.actions.displayInactif',
                  { number: getInactifNumber })
                : $t('produitSalon.regleCommission.actions.masquerInactif',
                  { number: getInactifNumber })
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <exportExcelButton
          :perm="permissions.exporter"
          :query="exportExcelQuery"/>
      </div>
    </div>
    <v-client-table
      :data="commissionsVendeur"
      class="overflow-x-auto min-height-50vw"
      :columns="columns"
      :options="options">
      <div slot="selected" slot-scope="props">
        <qd-checkbox
          v-model="props.row.selected"
          @input="updateLignes(props, 'selected')"
          class="mgt-5px">
        </qd-checkbox>
      </div>
      <div slot="commercial" slot-scope="props">
        <user-selector
          v-if="!detail"
          v-model="props.row.commercialId"
          @input="
            updateLignes(props, 'commercialId');
            if (isMultiSociete) $set(props.row, 'produitAchatCommissionId', null);
            updateLignes(props, 'produitAchatCommissionId');
          "
          :critere="(u) => [constantes.COMMERCIAL, constantes.DIRECTEUR_COMMERCIAL]
            .includes(u.profil)"
        />
        <span v-else> {{getUser(props.row.commercialId)}} </span>
      </div>
      <div slot="produitAchatCommissionId" slot-scope="props">
        <b-select
          v-if="!detail"
          v-model="props.row.produitAchatCommissionId"
          :disabled="!props.row.commercialId"
          @input="updateLignes(props, 'produitAchatCommissionId')"
          expanded>
          <option :value="null"></option>
          <option
            v-for="item in filteredProduitAchat(props)"
            :key="item.id"
            :value="item.id">
            {{ item.libelle }}
          </option>
        </b-select>
        <span v-else> {{ getRegleAchat(props.row.produitAchatCommissionId) }} </span>
      </div>
      <div slot="dateDebut" slot-scope="props">
        <b-datepicker
          v-if="!detail"
          v-model="props.row.dateDebut"
          @input="updateLignes(props, 'dateDebut')"
          icon="calendar-today"
          nearby-selectable-month-days
          editable show-week-number>
        </b-datepicker>
        <span v-else> {{props.row.dateDebut | formatDate}} </span>
      </div>
      <div slot="dateFin" slot-scope="props">
        <b-datepicker
          v-if="!detail"
          v-model="props.row.dateFin"
          @input="updateLignes(props, 'dateFin')"
          icon="calendar-today"
          nearby-selectable-month-days
          editable show-week-number>
        </b-datepicker>
        <span v-else> {{props.row.dateFin | formatDate}} </span>
      </div>
      <div slot="dateReference" slot-scope="props">
        <b-select
          v-if="!detail"
          v-model="props.row.dateReference"
          @input="updateLignes(props, 'dateReference')"
          expanded>
          <option
            v-for="item in constantes.COMMISSION_DATE_REFERENCE_TYPE"
            :key="item.value"
            :value="item.value">
            {{ $t(item.libelle) }}
          </option>
        </b-select>
        <span v-else> {{getCommissionDateReferenceType(props.row.dateReference)}} </span>
      </div>
      <div slot="calculAvance" slot-scope="props">
        <b-select
          v-if="!detail"
          v-model="props.row.calculAvance"
          @input="updateLignes(props, 'calculAvance')"
          expanded>
          <option
            v-for="item in constantes.COMMISSION_CALCUL_AVANCE_TYPE"
            :key="item.value"
            :value="item.value">
            {{ $t(item.libelle) }}
          </option>
        </b-select>
        <span v-else> {{getCommissionCalculAvanceType(props.row.calculAvance)}} </span>
      </div>
      <div slot="aSignature" slot-scope="props">
        <b-input
          v-if="!detail"
          v-model.number="props.row.aSignature"
          :use-html5-validation="false"
          @input="updateLignes(props, 'aSignature')"
          type="number"
          min="0" max="100"
          step="0.01">
        </b-input>
        <span v-else> {{getCommission(props.row.aSignature) | formatPercent}} </span>
      </div>
      <div slot="aEncaissement" slot-scope="props">
        <b-input
          v-if="!detail"
          v-model.number="props.row.aEncaissement"
          :use-html5-validation="false"
          @input="updateLignes(props, 'aEncaissement')"
          type="number"
          min="0" max="100"
          step="0.01">
        </b-input>
        <span v-else> {{getCommission(props.row.aEncaissement) | formatPercent}} </span>
      </div>
      <div slot="passeParMandataire" slot-scope="props">
        <b-input
          v-if="!detail"
          v-model.number="props.row.passeParMandataire"
          :use-html5-validation="false"
          @input="updateLignes(props, 'passeParMandataire')"
          type="number"
          min="0" max="100"
          step="0.01">
        </b-input>
        <span v-else> {{getCommission(props.row.passeParMandataire) | formatPercent}} </span>
      </div>
      <div slot="aSignatureNvClient" slot-scope="props">
        <b-input
          v-if="!detail"
          v-model.number="props.row.aSignatureNvClient"
          :use-html5-validation="false"
          @input="updateLignes(props, 'aSignatureNvClient')"
          type="number"
          min="0" max="100"
          step="0.01">
        </b-input>
        <span v-else> {{getCommission(props.row.aSignatureNvClient) | formatPercent}} </span>
      </div>
      <div slot="aEncaissementNvClient" slot-scope="props">
        <b-input
          v-if="!detail"
          v-model.number="props.row.aEncaissementNvClient"
          :use-html5-validation="false"
          @input="updateLignes(props, 'aEncaissementNvClient')"
          type="number"
          min="0" max="100"
          step="0.01">
        </b-input>
        <span v-else> {{getCommission(props.row.aEncaissementNvClient) | formatPercent}} </span>
      </div>
      <div slot="archive" slot-scope="props">
        <div v-if="!detail" class="has-text-centered">
          <qd-checkbox
            v-model="props.row.archive"
            @input="updateLignes(props, 'archive')"
            class="mgt-5px">
          </qd-checkbox>
        </div>
        <span v-else> {{ $t(`general.${props.row.archive ? 'oui' : 'non'}`) }} </span>
      </div>
      <div slot="delete" slot-scope="props">
        <a @click="deleteLigne(props.index)">
          <b-icon icon="delete-forever" type="is-danger" class="mgt-5px"/>
        </a>
      </div>
    </v-client-table>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genereRegleCommissionLigne from '@/services/presse/salon/genereRegleCommissionLigne';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
  NO_PAGINATION,
} from '@/configuration/clientTableConf';
import { PGetAllTiersByUserIds } from '@/api/tiers';
import selecteurAction from '@/components/general/selecteurAction';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import MsgInfoProduit from '@/components/presse/regroupementProduit/informations/MsgInfoProduit';
import userSelector from '@/components/commun/user/userSelector';
import messageErreur from '@/services/general/messageErreur';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { columnsSplice } from '@/services/general/columns';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { EXPORT_EXCEL_COMMISSIONS_VENDEUR } from '@/configuration/presse/produitPresse/produitPresseConf';
import { getAll as getAllDivers } from '@/api/produit/produitDivers';
import { SENS_ACHAT } from '@/configuration/devisConf';
import {
  ACTION_SUPPRESSION, COMMISSION_CALCUL_AVANCE_TYPE,
  COMMISSION_DATE_REFERENCE_TYPE, ACTION_ARCHIVER,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
    showMsgRegroupementProduit: {
      type: Boolean,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  components: {
    selecteurAction,
    MsgInfoProduit,
    userSelector,
    exportExcelButton,
  },
  data() {
    return {
      isLoad: false,
      displayInactif: true,
      constantes: {
        COMMISSION_DATE_REFERENCE_TYPE,
        COMMISSION_CALCUL_AVANCE_TYPE,
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
      },
      actions: [
        { action: ACTION_SUPPRESSION, translation: 'produitSalon.regleCommission.actions.supprimer' },
        { action: ACTION_ARCHIVER, translation: 'produitSalon.regleCommission.actions.archiver' },
      ],
      allProduitAchat: [],
      tiersFromUsers: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    isMultiSociete() {
      return this.societesInformations.length > 1;
    },
    allIsSelected() {
      return this.getAllSelected.length === this.produit.commissionsVendeur.length;
    },
    iconSelectTotal() {
      if (this.allIsSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          commercial: this.$t('produitSalon.regleCommission.information.commercial'),
          produitAchatCommissionId: this.$t('produitSalon.regleCommission.information.produitAchat'),
          dateDebut: this.$t('produitSalon.regleCommission.information.dateDebut'),
          dateFin: this.$t('produitSalon.regleCommission.information.dateFin'),
          dateReference: this.$t('produitSalon.regleCommission.information.dateReference'),
          calculAvance: this.$t('produitSalon.regleCommission.information.calculAvance'),
          aSignature: this.$t('produitSalon.regleCommission.information.aSignature'),
          aEncaissement: this.$t('produitSalon.regleCommission.information.aEncaissement'),
          passeParMandataire: this.$t('produitSalon.regleCommission.information.passeParMandataire'),
          aSignatureNvClient: this.$t('produitSalon.regleCommission.information.aSignatureNvClient'),
          aEncaissementNvClient: this.$t('produitSalon.regleCommission.information.aEncaissementNvClient'),
          archive: this.$t('produitSalon.regleCommission.information.archive'),
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allIsSelected;
                    this.produit.commissionsVendeur.forEach(c => {
                      c.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          dateDebut: 'colonneMinWidth-150px',
          dateFin: 'colonneMinWidth-150px',
          commercial: 'colonneMinWidth-150px',
          dateReference: 'colonneMinWidth-150px',
          calculAvance: 'colonneMinWidth-150px',
        },
        sortable: this.detail ? ['commercial', 'produitAchatCommissionId', 'dateDebut', 'dateFin', 'dateReference', 'calculAvance', 'aSignature', 'aEncaissement', 'passeParMandataire', 'aSignatureNvClient', 'aEncaissementNvClient'] : [],
      };
    },
    columns() {
      const columns = ['selected', 'commercial', 'produitAchatCommissionId', 'dateDebut', 'dateFin', 'dateReference', 'calculAvance', 'aSignature', 'aEncaissement', 'passeParMandataire', 'aSignatureNvClient', 'aEncaissementNvClient', 'archive', 'delete'];
      if (this.detail) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    users() {
      const items = this.parametre(typesParametres.PARAMETRES_KEYS.utilisateur)
        .filter((user) => user.profil === COMMERCIAL || user.profil === DIRECTEUR_COMMERCIAL)
        .sort((a, b) => {
          if (a.decorator.nomPrenom < b.decorator.nomPrenom) return -1;
          if (a.decorator.nomPrenom > b.decorator.nomPrenom) return 1;
          return 0;
        });
      return items;
    },
    getAllSelected() {
      return this.produit.commissionsVendeur.filter(c => c.selected);
    },
    commissionsVendeur() {
      if (this.displayInactif) {
        return this.produit.commissionsVendeur
          .filter(el => el.archive === !this.displayInactif);
      }
      return this.produit.commissionsVendeur;
    },
    getInactifNumber() {
      return this.produit.commissionsVendeur
        .filter((encart) => { return encart.archive === true; }).length;
    },
    filteredProduitAchat() {
      return (props) => {
        const societeId = this.tiersFromUsers.find(t => {
          return t.lienUtilisateurId === props.row.commercialId;
        })?.societeId ?? null;
        return this.allProduitAchat.filter(p => p.supportCommercial.societeId === societeId);
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_COMMISSIONS_VENDEUR,
        typeExport: null,
        filtres: {
          query: { produitId: this.produit.id },
          displayInactif: this.displayInactif,
        },
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getCommission(pourcentage) {
      return pourcentage === null ? 0 : pourcentage;
    },
    getUser(id) {
      const find = this.users.find(u => u.id === id);
      if (find) return find.decorator.nomPrenom;
      return '';
    },
    getRegleAchat(id) {
      if (id === null) return this.$t('societes.produitDefaut');
      return this.allProduitAchat.find(p => p.id === id)?.libelle ?? '';
    },
    getCommissionDateReferenceType(value) {
      const find = COMMISSION_DATE_REFERENCE_TYPE.find(c => c.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    getCommissionCalculAvanceType(value) {
      const find = COMMISSION_CALCUL_AVANCE_TYPE.find(c => c.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    addLigne() {
      this.produit.commissionsVendeur.push(genereRegleCommissionLigne());
    },
    updateLignes(props, key) {
      const ligneFind = this.produit.commissionsVendeur[props.index - 1];
      if (ligneFind) this.$set(ligneFind, key, props.row[key]);
    },
    deleteLigne(propsIndex) {
      this.produit.commissionsVendeur.splice(propsIndex - 1, 1);
    },
    handleAction(type) {
      switch (type) {
        case ACTION_SUPPRESSION:
          if (!this.allIsSelected) {
            this.getAllSelected.forEach(el => {
              const index = this.produit.commissionsVendeur.indexOf(el);
              if (index !== -1) this.deleteLigne(index + 1);
            });
          } else this.produit.commissionsVendeur = [];
          break;
        case ACTION_ARCHIVER:
          this.getAllSelected.forEach(el => {
            const index = this.produit.commissionsVendeur.indexOf(el);
            if (index !== -1) {
              this.updateLignes({
                row: { ...el, archive: true },
                index: index + 1,
              }, 'archive');
            }
          });
          break;
        default:
          break;
      }
    },
  },
  async mounted() {
    this.isLoad = false;
    if (!this.detail) this.displayInactif = false;
    const queryItemDivers = {
      query: {
        sens: SENS_ACHAT,
        actif: true,
      },
      orderBy: 'ProduitDivers.Quantite, Libelle',
      ascending: true,
      maxResultCount: NO_PAGINATION,
    };
    const loadingComponent = this.$buefy.loading.open();
    try {
      const [produits, tiers] = (await Promise.all([
        getAllDivers(queryItemDivers),
        PGetAllTiersByUserIds({ usersIds: this.users.map(u => u.id) }),
        this.loadParametreUtilisateur(),
      ]));
      this.allProduitAchat = produits.data.result.items;
      this.tiersFromUsers = tiers.data.result;
      this.isLoad = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
